import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function copaService() {
  const api = () => useApi()

  const options = {
    ignoreGlobalParams: true,
  }

  async function getAuth(params) {
    return api().query(`${URLS.copa_auth}`, params)
  }

  async function getTierList(params) {
    return api().query(`${URLS.copa_tiers}`, params, options)
  }

  async function getReportsSummary(params) {
    return api().query(`${URLS.reports_summary}`, params, options)
  }

  async function getReportsOverview(params) {
    return api().query(`${URLS.reports_overview}`, params, options)
  }

  function getReportsEvolution(params) {
    return api().query(`${URLS.reports_evolution}`, params, options)
  }

  function getReportsEnablers(params) {
    return api().query(`${URLS.reports_enablers}`, params, options)
  }

  function getReportsQuickWins(params) {
    return api().query(`${URLS.reports_quick_wins}`, params, options)
  }

  function getReportsHighlights(params) {
    return api().query(`${URLS.reports_highlights}`, params, options)
  }

  function getReportsPilar(params) {
    return api().query(`${URLS.reports_pilar}`, params, options)
  }

  function getZonesList(params) {
    return api().query(`${URLS.zones}`, params, options)
  }

  function getBottlersList(params) {
    return api().query(`${URLS.bottlers}`, params, options)
  }

  return {
    getAuth,
    getTierList,
    getReportsSummary,
    getReportsOverview,
    getReportsEvolution,
    getReportsEnablers,
    getReportsQuickWins,
    getReportsHighlights,
    getReportsPilar,
    getZonesList,
    getBottlersList,
  }
}
